var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFetImg6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 88,
    viewBox: "0 0 132 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.910156,
    width: 130.583,
    height: 87.9271,
    rx: 11.5157,
    fill: "#E8F7E3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.1218 28.9761L66.402 34.6941V60.9502H46.4043V28.9761H68.1218Z",
    fill: "#4ABBEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4043 44.9619H66.402V60.9484H46.4043V44.9619Z",
    fill: "#009BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1378 21.2207H48.1246V71H40.1378V21.2207Z",
    fill: "#2F5995"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1309 21.2207H48.1237V71H44.1309V21.2207Z",
    fill: "#183158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8224 24.9132C46.803 25.9326 45.4677 26.4429 44.1314 26.4429C42.7951 26.4429 41.4587 25.9326 40.4393 24.9132C38.4004 22.8743 38.4004 19.5689 40.4393 17.5301C41.4587 16.5106 42.7951 16.0015 44.1314 16.0015C45.4677 16.0015 46.803 16.5106 47.8224 17.5301C49.8613 19.5689 49.8613 22.8743 47.8224 24.9132Z",
    fill: "#FFDA2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8219 24.9132C46.8024 25.9326 45.4672 26.4429 44.1309 26.4429V16.0015C45.4672 16.0015 46.8024 16.5106 47.8219 17.5301C49.8607 19.5689 49.8607 22.8743 47.8219 24.9132Z",
    fill: "#FDBF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1224 28.9761L57.0586 38.0021L58.7785 41.694H68.1224V28.9761Z",
    fill: "#009BE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.5485 54.501L93.9102 71.001H57.0586V38.001H93.9102L84.5485 54.501Z",
    fill: "#A4FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9102 71.0005H57.0586V54.5005H84.5485L93.9102 71.0005Z",
    fill: "#4ABBEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "white",
    transform: "translate(38.9102 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFetImg6);
export default __webpack_public_path__ + "static/media/fet-img (6).5d0c151193ed0716b6401783161044d1.svg";
export { ForwardRef as ReactComponent };